import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';

import { ApContentService } from '@ap/content';

import content from './conversational-chat-inactivityprompt.content.json';

@Component({
    selector: 'conversational-chat-inactivityprompt',
    templateUrl: './conversational-chat-inactivityprompt.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConversationalChatInactivitypromptComponent {
    private readonly contentService = inject(ApContentService);

    public readonly promptSelectContinue = output<void>();
    public readonly promptSelectEnd = output<void>();

    public constructor() {
        this.contentService.addContentItems(content);
    }

    public setSelectContinue(): void {
        this.promptSelectContinue.emit();
    }

    public setSelectEnd(): void {
        this.promptSelectEnd.emit();
    }
}
